import MainLayout from '../layouts/main';
import RankingContainer from './container';

function ExamRankingPage() {
  return (
    <MainLayout title={EXAM_RANKING_PAGE_TITLE}>
      <RankingContainer />
    </MainLayout>
  );
}

export const EXAM_RANKING_PAGE_TITLE = 'جدول رتبه‌ها';

export default ExamRankingPage;
